

    <div class="inner-page-sidedetails">
        <div class="row">
            <div class="col-lg-12"  *ngFor="let items of PageContent">
                <div class="inner-banner-image" *ngIf="items.featureImage!==''">
                    <div class="image-area">
                        <img class="screen-reader" src="{{backendUrl}}storage/app/uploads/{{items.featureImage}}" alt="inner-banner-image">
                    </div>
                </div>
                <div class="details">
                    <div class="title">
                        <h3 class="screen-reader">{{items.pageTitleInEnglish}}</h3>
                    </div>
                    <div class="description">
                        <div class="screen-reader" [innerHtml]="items.content"></div>
                     
                    </div>
                </div>
            </div>
        </div>
    </div>
     
